<template>
    <section class="flex w-full flex-col gap-5 lg:gap-8">
        <CartToggleButton class="lg:hidden" />
        <OrderNotifications />
        <CategoryList />
    </section>
</template>

<script setup>
    import CartToggleButton from '~/components/Cart/CartToggleButton.vue'
    import CategoryList from '~/components/Category/CategoryList.vue'
    import OrderNotifications from '~/components/OrderNotifications.vue'
    import { getTargetDispatchType } from '~/composables/navigateToDispatchType'
    import { checkout } from '~/store/checkout'
    const route = useRoute()
    const dispatchType = getTargetDispatchType(route.fullPath)
    if (process.server) {
        await checkout().setDispatchType(dispatchType, false)
    }
    definePageMeta({
        pageTransition: {
            name: 'fade-up-delay'
        }
    })
    onMounted(async () => {
        await checkout().setDispatchType(dispatchType, false)
    })
</script>
